import { accountDiscoveryTypes } from 'app-components/flux/account-discovery';
import { DIALOG_TYPE_NPS_SURVEY } from 'app-components/flux/nps';

import { BARCHART_DIALOG } from 'components/BarchartDialog/dispatcher';
import { BILL_SETUP_FLOW_DIALOG_TYPE } from 'components/BillScoutSetup/dispatcher';
import { REAUTHENTICATION_DIALOG } from 'components/Dialogs/AccountDiscovery/ReauthDialog/dispatcher';
import {
  DIALOG_TYPE_ACCOUNTS_TRANSFERS,
  DIALOG_TYPE_FUNDING_ACCOUNT_LOCKOUT,
  DIALOG_TYPE_MICRODEPOSIT_CONFIRMATION_FOR_TRANSFERS,
  DIALOG_TYPE_ONBOARD_ACCOUNTS_FOR_TRANSFERS,
  DIALOG_TYPE_TRANSFER_ACTIVITY_DETAILS,
} from 'components/Dialogs/A2A/actions';
import { AI_LEGAL_DISCLAIMER } from 'components/Dialogs/AILegalDisclaimer/dispatcher';
import { AI_SUMMARY_DIALOG } from 'components/Dialogs/AiSummary/dispatcher';
import AlertDialog from 'components/Dialogs/AlertDialog';
import { DIALOG_TYPE as DIALOG_TYPE_ALERT } from 'components/Dialogs/AlertDialog/types';
import { DIALOG_TYPE_ASSET } from 'components/Dialogs/AssetDialog/actions';
import {
  DETAILS_DIALOG_TYPE as DIALOG_TYPE_BILL_PRESENTMENT_DETAILS,
  DIALOG_TYPE as DIALOG_TYPE_BILL_PRESENTMENT,
} from 'components/Dialogs/BillPresentment/actions';
import { DIALOG_TYPE as DIALOG_TYPE_BILL_SCOUT } from 'components/Dialogs/BillScout/actions';
import { DIALOG_TYPE as DIALOG_TYPE_CANCEL_TRANSACTION_RULE } from 'components/Dialogs/CancelTransactionRule/actions';
import { CHAT_DISCLAIMER } from 'components/Dialogs/ChatDisclaimer/dispatcher';
import ConfirmationDialog, { DIALOG_TYPE as DIALOG_TYPE_CONFIRMATION } from 'components/Dialogs/ConfirmationDialog';
import {
  DIALOG_TYPE_CANCEL_REGISTRATION,
  DIALOG_TYPE_CREDIT_REPORT_UPDATE,
  DIALOG_TYPE_CREDIT_SCORE_LOADING,
  DIALOG_TYPE_CREDIT_SCORE_REGISTER,
  DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_EVENTS,
  DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_SENT,
} from 'components/Dialogs/CreditScore/actions';
import { DIALOG_TYPE as DIALOG_TYPE_PLANNED_SPENDING_DELETE } from 'components/Dialogs/DeletePlannedSpending/actions';
import {
  DIALOG_TYPE_ACCOUNT_EDIT,
  DIALOG_TYPE_EMAIL_VERIFICATION_DIALOG,
  DIALOG_TYPE_IDENTITY_VERIFICATION_DIALOG,
  DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT,
  DIALOG_TYPE_LLM_GOAL,
  DIALOG_TYPE_LLM_GOAL_CONTRIBUTE,
  DIALOG_TYPE_LLM_RECURRING,
  DIALOG_TYPE_LLM_RULE,
  DIALOG_TYPE_LLM_TRANSACTION,
  DIALOG_TYPE_LLM_WATCHLIST,
  DIALOG_TYPE_PHONE_VERIFICATION_DIALOG,
  DIALOG_TYPE_REFUND_EDIT,
  DIALOG_TYPE_REFUND_MATCH,
  DIALOG_TYPE_REVIEW_CATEGORY,
  DIALOG_TYPE_SECURITY_EDIT,
} from 'components/Dialogs/dialogTypes';
import { DIALOG_TYPE as DIALOG_TYPE_DELETE_REMINDER } from 'components/Dialogs/DeleteReminderDialog/actions';
import { DIALOG_TYPE as DIALOG_TYPE_DELETE_TRANSACTION_RULE } from 'components/Dialogs/DeleteTransactionRule/actions';
import { DIALOG_TYPE as DIALOG_TYPE_EDIT_REMINDER } from 'components/Dialogs/EditReminderDialog/actions';
import { DIALOG_TYPE as DIALOG_TYPE_PLANNED_SPENDING_EDIT } from 'components/Dialogs/EditPlannedSpending/actions';
import { DIALOG_TYPE as EDIT_PLANNED_SPENDING_INSTANCE_DIALOG } from 'components/Dialogs/EditPlannedSpendingInstance/actions';
import { DIALOG_TYPE as EDIT_PLANNED_SPENDING_SERIES_DIALOG } from 'components/Dialogs/EditPlannedSpendingSeries/actions';
import { EDIT_PROMPT_DIALOG } from 'components/Dialogs/EditPrompt/dispatcher';
import EmptyDialog, { DIALOG_TYPE_EMPTY_DIALOG } from 'components/Dialogs/EmptyDialog';
import { DIALOG_TYPE as DIALOG_TYPE_FIRST_USE_V2 } from 'components/Dialogs/FirstTimeUse/spendingPlanFirstUseV2/actions';
import { DIALOG_TYPE as DIALOG_TYPE_SWL_FIRST_USE } from 'components/Dialogs/FirstTimeUse/watchlistFirstUse/actions';
import {
  ADD_GOAL_DIALOG_TYPE as DIALOG_TYPE_ADD_GOAL,
  CONTRIBUTE_TO_GOAL_DIALOG_TYPE as DIALOG_TYPE_CONTRIBUTE_TO_GOAL,
  WITHDRAW_FROM_GOAL_DIALOG_TYPE as DIALOG_TYPE_WITHDRAW_FROM_GOAL,
} from 'components/Dialogs/Goals/actions';
import { INVOICE_ITEM_IMPORT_DIALOG } from 'components/Dialogs/InvoiceItemImportDialog/dispatcher';
import { MANAGE_UPDATES_DIALOG } from 'components/Dialogs/ManageUpdatesDialog/dispatcher';
import { DIALOG_TYPE as DIALOG_TYPE_MATCH_TXN } from 'components/Dialogs/MatchTxnDialog/actions';
import NotificationDialog from 'components/Dialogs/NotificationDialog';
import { DIALOG_TYPE as DIALOG_TYPE_NOTIFICATION } from 'components/Dialogs/NotificationDialog/types';
import { DIALOG_TYPE as DIALOG_TYPE_PLANNED_SPENDING } from 'components/Dialogs/AddPlannedSpending/actions';
import ReportErrorDialog, { DIALOG_TYPE_REPORT_ERROR } from 'components/Dialogs/ReportErrorDialog';
import RefreshTimeoutDialog, {
  DIALOG_TYPE as DIALOG_TYPE_REFRESH_TIMEOUT,
} from 'components/Dialogs/RefreshTimeoutDialog';
import { DIALOG_TYPE_REVIEW_RENAME_PAYEE } from 'components/Dialogs/ReviewRenamePayeeDialog/actions';
import { DIALOG_TYPE as DIALOG_TYPE_SCHEDULED_TRANSACTION_ADD } from 'components/Dialogs/ScheduledTransactionAddDialog/actions';
import { SELECT_LOGO_DIALOG } from 'components/Dialogs/SelectLogoDialog/dispatcher';
import { DIALOG_TYPE as DIALOG_TYPE_MEMORIZED_RULE_EDIT } from 'components/Dialogs/TransactionRules/actions';
import { DIALOG_TYPE_TXN_SETTINGS } from 'components/Dialogs/TransactionsSettingsDialog/actions';
import { DIALOG_TYPE as DIALOG_TYPE_VIEW_SERIES } from 'components/Dialogs/ViewSeriesDialog/actions';
import { DIALOG_TYPE as DIALOG_TYPE_WATCHLIST } from 'components/Dialogs/WatchlistModal/actions';
import { DIALOG_TYPE as DIALOG_TYPE_COBROWSE_CODE_FETCH } from 'components/Dialogs/CobrowseCodeFetch/actions';
import { HOLDING_DIALOG } from 'components/Forms/HoldingForm/dispatcher';
import { RECURRING_SETUP_DIALOG } from 'components/GettingStartedAcme/Recurring/RecurringSetupDialog/dispatcher';
import { INVOICE_ITEM_ROOTUI_TYPE } from 'components/InvoiceItemModal/actions';
import { INVOICE_PAYMENT_ROOTUI_TYPE } from 'components/InvoicePayment/actions';
import { INVOICE_SEND_ROOTUI_TYPE } from 'components/InvoiceSendModal/actions';
import { MATCH_SALES_RECEIPT_ROOTUI_TYPE } from 'components/ReceiptMatch/actions';
import { REQUEST_DIALOG } from 'components/RequestDialog/dispatcher';
import { SALES_TAX_ROOTUI_TYPE } from 'components/SalesTaxModal/actions';
import { BUSINESS_INCOME_DEDUCTIONS_MODAL } from 'components/TaxPlanner/BusinessIncomeDeductionsModal/dispatcher';
import { CREATE_TAX_SERIES_DIALOG } from 'components/TaxPlanner/CreateTaxSeriesDialog/dispatcher';
import { FILING_DETAILS_MODAL } from 'components/TaxPlanner/FilingDetailsModal/dispatcher';
import { HOW_WE_CALCULATE_MODAL } from 'components/TaxPlanner/HowWeCalculateModal/dispatcher';
import { TAX_PLANNER_DIALOG } from 'components/TaxPlanner/TaxPlannerDialog/dispatcher';
import { DIALOG_TYPE as DIALOG_TYPE_TRANSACTION_DETAILS } from 'components/Dialogs/TransactionEditDialog/actions';
import { GENERATOR_DIALOG } from 'components/Transactions/GeneratorDialog/dispatcher';
import { DIALOG_TYPE as DIALOG_TYPE_SPLIT_DIALOG } from 'components/Transactions/SplitDialog/actions';
import { DIALOG_TYPE as DIALOG_TYPE_SCHEDULED_TRANSACTION_EDIT } from 'components/Dialogs/ScheduledTransactionEditDialog/actions';
import { EDIT_DIALOG_TYPE as DIALOG_TYPE_EDIT_GOAL } from 'containers/Goals/EditGoal/actions';
import { INVOICE_FORM_ROOTUI_TYPE } from 'containers/InvoiceForm/actions';
import { UPGRADE_TO_BUSINESS_ROOTUI_TYPE } from 'containers/UpgradeToBusiness/actions';

import { ImportModalComponent, RegisterModalComponent } from './modalRegistry';

// Small dialogs that error and offline paths open, including Report a problem, stay eager so they work even
// when chunks can't load.
RegisterModalComponent(DIALOG_TYPE_ALERT, AlertDialog);
RegisterModalComponent(DIALOG_TYPE_CONFIRMATION, ConfirmationDialog);
RegisterModalComponent(DIALOG_TYPE_NOTIFICATION, NotificationDialog);
RegisterModalComponent(DIALOG_TYPE_REFRESH_TIMEOUT, RefreshTimeoutDialog);
RegisterModalComponent(DIALOG_TYPE_EMPTY_DIALOG, EmptyDialog);
RegisterModalComponent(DIALOG_TYPE_REPORT_ERROR, ReportErrorDialog);

// shared
ImportModalComponent(DIALOG_TYPE_LLM_GOAL, () => import('components/Dialogs/LlmGoalDialog'));
ImportModalComponent(DIALOG_TYPE_LLM_GOAL_CONTRIBUTE, () => import('components/Dialogs/LlmGoalContributionDialog'));
ImportModalComponent(DIALOG_TYPE_LLM_RECURRING, () => import('components/Dialogs/LlmRecurringDialog'));
ImportModalComponent(DIALOG_TYPE_LLM_RULE, () => import('components/Dialogs/LlmRuleDialog'));
ImportModalComponent(DIALOG_TYPE_LLM_TRANSACTION, () => import('components/Dialogs/LlmTransactionDialog'));
ImportModalComponent(DIALOG_TYPE_LLM_WATCHLIST, () => import('components/Dialogs/LlmWatchlistDialog'));
ImportModalComponent(DIALOG_TYPE_REVIEW_CATEGORY, () => import('components/Dialogs/ReviewLlmCatagoriesDialog.tsx'));
ImportModalComponent(DIALOG_TYPE_REVIEW_RENAME_PAYEE, () => import('components/Dialogs/ReviewRenamePayeeDialog'), {
  rootModalDrawer: { width: 'Medium' },
});
ImportModalComponent(DIALOG_TYPE_TXN_SETTINGS, () => import('components/Dialogs/TransactionsSettingsDialog'));
ImportModalComponent(
  accountDiscoveryTypes.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
  () => import('components/Dialogs/AccountDiscovery'),
);
ImportModalComponent(DIALOG_TYPE_ASSET, () => import('components/Dialogs/AssetDialog'));
ImportModalComponent(DIALOG_TYPE_NPS_SURVEY, () => import('components/Dialogs/NPSSurveyDialog'));
ImportModalComponent(DIALOG_TYPE_ADD_GOAL, () => import('components/Dialogs/Goals/AddGoal'));
ImportModalComponent(DIALOG_TYPE_WITHDRAW_FROM_GOAL, () => import('components/Dialogs/Goals/WithdrawFromGoal'));
ImportModalComponent(DIALOG_TYPE_CONTRIBUTE_TO_GOAL, () => import('components/Dialogs/Goals/ContributeToGoal'));
ImportModalComponent(
  DIALOG_TYPE_FIRST_USE_V2,
  () => import('components/Dialogs/FirstTimeUse/spendingPlanFirstUseV2/spendingPlanFirstUseV2'),
);
ImportModalComponent(DIALOG_TYPE_SWL_FIRST_USE, () => import('components/Dialogs/FirstTimeUse/watchlistFirstUse'));
ImportModalComponent(DIALOG_TYPE_WATCHLIST, () => import('components/Dialogs/WatchlistModal'));
ImportModalComponent(
  DIALOG_TYPE_ONBOARD_ACCOUNTS_FOR_TRANSFERS,
  () => import('components/Dialogs/A2A/OnboardAccountsForTransfers'),
);
ImportModalComponent(
  DIALOG_TYPE_MICRODEPOSIT_CONFIRMATION_FOR_TRANSFERS,
  () => import('components/Dialogs/A2A/MicrodepositConfirmationDialog'),
);
ImportModalComponent(DIALOG_TYPE_FUNDING_ACCOUNT_LOCKOUT, () => import('components/Dialogs/A2A/AccountLockoutDialog'));
ImportModalComponent(DIALOG_TYPE_ACCOUNTS_TRANSFERS, () => import('components/Dialogs/A2A/AccountTransfersDialog'));
ImportModalComponent(
  DIALOG_TYPE_TRANSFER_ACTIVITY_DETAILS,
  () => import('components/Dialogs/A2A/TransferActivityDetails'),
);
ImportModalComponent(
  DIALOG_TYPE_INVESTMENT_TRANSACTIONS_EDIT,
  () => import('components/Dialogs/InvestmentTransactionEditDialog'),
  {
    rootModalDrawer: { width: 'Large' },
  },
);
ImportModalComponent(DIALOG_TYPE_SECURITY_EDIT, () => import('components/Dialogs/SecurityEditDialog'));
ImportModalComponent(BARCHART_DIALOG, () => import('components/BarchartDialog'));
ImportModalComponent(DIALOG_TYPE_DELETE_REMINDER, () => import('components/Dialogs/DeleteReminderDialog'));
ImportModalComponent(DIALOG_TYPE_DELETE_TRANSACTION_RULE, () => import('components/Dialogs/DeleteTransactionRule'));
ImportModalComponent(DIALOG_TYPE_CANCEL_TRANSACTION_RULE, () => import('components/Dialogs/CancelTransactionRule'));
ImportModalComponent(DIALOG_TYPE_MATCH_TXN, () => import('components/Dialogs/MatchTxnDialog'), {
  rootModalDrawer: { width: 'Large' },
});
ImportModalComponent(DIALOG_TYPE_PLANNED_SPENDING, () => import('components/Dialogs/AddPlannedSpending'));
ImportModalComponent(DIALOG_TYPE_PLANNED_SPENDING_EDIT, () => import('components/Dialogs/EditPlannedSpending'));
ImportModalComponent(
  EDIT_PLANNED_SPENDING_INSTANCE_DIALOG,
  () => import('components/Dialogs/EditPlannedSpendingInstance'),
);
ImportModalComponent(EDIT_PLANNED_SPENDING_SERIES_DIALOG, () => import('components/Dialogs/EditPlannedSpendingSeries'));
ImportModalComponent(DIALOG_TYPE_PLANNED_SPENDING_DELETE, () => import('components/Dialogs/DeletePlannedSpending'));
ImportModalComponent(DIALOG_TYPE_EDIT_REMINDER, () => import('components/Dialogs/EditReminderDialog'), {
  rootModalDrawer: { width: 'Large' },
});
ImportModalComponent(DIALOG_TYPE_VIEW_SERIES, () => import('components/Dialogs/ViewSeriesDialog'), {
  rootModalDrawer: { width: 'Large' },
});
ImportModalComponent(DIALOG_TYPE_BILL_PRESENTMENT, () => import('components/Dialogs/BillPresentment'));
ImportModalComponent(
  DIALOG_TYPE_BILL_PRESENTMENT_DETAILS,
  () => import('components/Dialogs/BillPresentment/BillPresentmentDetailsDialog'),
);
ImportModalComponent(DIALOG_TYPE_BILL_SCOUT, () => import('components/Dialogs/BillScout'));
ImportModalComponent(DIALOG_TYPE_REFUND_EDIT, () => import('components/Dialogs/RefundEditDialog'), {
  rootModalDrawer: { width: 'Large' },
});
ImportModalComponent(DIALOG_TYPE_REFUND_MATCH, () => import('components/Dialogs/RefundMatchDialog'));
ImportModalComponent(
  DIALOG_TYPE_SCHEDULED_TRANSACTION_ADD,
  () => import('components/Dialogs/ScheduledTransactionAddDialog'),
  {
    rootModalDrawer: { width: 'Large' },
  },
);
ImportModalComponent(DIALOG_TYPE_MEMORIZED_RULE_EDIT, () => import('components/Dialogs/TransactionRules'));
ImportModalComponent(DIALOG_TYPE_ACCOUNT_EDIT, () => import('components/Dialogs/AccountEditDialog'));
ImportModalComponent(DIALOG_TYPE_IDENTITY_VERIFICATION_DIALOG, () => import('components/Dialogs/IdentityVerification'));
ImportModalComponent(DIALOG_TYPE_TRANSACTION_DETAILS, () => import('components/Dialogs/TransactionEditDialog'), {
  // Opens at the previous 'Large' width; the enhanced skinny view narrows it to 'Small' at render
  // time (via the view model's width rebroadcast) when transactionsEnhancedDetailViewRelease is on.
  rootModalDrawer: { width: 'Large', showScrim: true },
});
ImportModalComponent(DIALOG_TYPE_SPLIT_DIALOG, () => import('components/Transactions/SplitDialog'));
ImportModalComponent(
  DIALOG_TYPE_SCHEDULED_TRANSACTION_EDIT,
  () => import('components/Dialogs/ScheduledTransactionEditDialog'),
);
ImportModalComponent(DIALOG_TYPE_PHONE_VERIFICATION_DIALOG, () => import('components/Dialogs/PhoneVerification'));
ImportModalComponent(DIALOG_TYPE_EMAIL_VERIFICATION_DIALOG, () => import('components/Dialogs/EmailVerification'));
ImportModalComponent(
  DIALOG_TYPE_CREDIT_SCORE_REGISTER,
  () => import('components/Dialogs/CreditScore/CreditScoreRegistrationDialog'),
);
ImportModalComponent(
  DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_SENT,
  () => import('components/Dialogs/CreditScore/CreditScoreVerificationSentDialog'),
);
ImportModalComponent(
  DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_EVENTS,
  () => import('components/Dialogs/CreditScore/CreditScoreVerificationEventsDialog'),
);
ImportModalComponent(DIALOG_TYPE_CREDIT_SCORE_LOADING, () => import('components/Dialogs/CreditScore/LoadingDialog'));
ImportModalComponent(
  DIALOG_TYPE_CREDIT_REPORT_UPDATE,
  () => import('components/Dialogs/CreditScore/CreditReportUpdateDialog'),
);
ImportModalComponent(
  DIALOG_TYPE_CANCEL_REGISTRATION,
  () => import('components/Dialogs/CreditScore/CancelRegistrationDialog'),
);
ImportModalComponent(MANAGE_UPDATES_DIALOG, () => import('components/Dialogs/ManageUpdatesDialog'));
ImportModalComponent(REAUTHENTICATION_DIALOG, () => import('components/Dialogs/AccountDiscovery/ReauthDialog'));
ImportModalComponent(DIALOG_TYPE_COBROWSE_CODE_FETCH, () => import('components/Dialogs/CobrowseCodeFetch'));
// The invoice form renders its own full-screen StdDialog (pinned to the drawer
// plane via getInvoiceFormDialogSx), so it must never be promoted to an overlay
// drawer shell when launched from a drawer — that shell would render empty and
// still push a left edge over the invoice. Keep it on the modal presentation path.
ImportModalComponent(INVOICE_FORM_ROOTUI_TYPE, () => import('containers/InvoiceForm'), {
  rootModalPresentation: 'modal',
});
// Invoice payment renders its own StdDialog, so it must never be promoted to an
// overlay drawer shell when launched from a drawer — the dialog portals back out
// to document.body and the shell is left drawing nothing but its own paper and
// edge over whatever is below. Same reason as the invoice form above.
ImportModalComponent(INVOICE_PAYMENT_ROOTUI_TYPE, () => import('components/InvoicePayment'), {
  rootModalPresentation: 'modal',
});
ImportModalComponent(MATCH_SALES_RECEIPT_ROOTUI_TYPE, () => import('components/ReceiptMatch/MatchSalesReceipt'));
ImportModalComponent(BILL_SETUP_FLOW_DIALOG_TYPE, () => import('components/BillScoutSetup'));
ImportModalComponent(AI_LEGAL_DISCLAIMER, () => import('components/Dialogs/AILegalDisclaimer'));
ImportModalComponent(AI_SUMMARY_DIALOG, () => import('components/Dialogs/AiSummary'));
ImportModalComponent(CHAT_DISCLAIMER, () => import('components/Dialogs/ChatDisclaimer'));
ImportModalComponent(EDIT_PROMPT_DIALOG, () => import('components/Dialogs/EditPrompt'));
ImportModalComponent(INVOICE_ITEM_IMPORT_DIALOG, () => import('components/Dialogs/InvoiceItemImportDialog'));
ImportModalComponent(SELECT_LOGO_DIALOG, () => import('components/Dialogs/SelectLogoDialog'));
ImportModalComponent(HOLDING_DIALOG, () => import('components/Forms/HoldingForm'));
ImportModalComponent(
  RECURRING_SETUP_DIALOG,
  () => import('components/GettingStartedAcme/Recurring/RecurringSetupDialog'),
);
ImportModalComponent(INVOICE_ITEM_ROOTUI_TYPE, () => import('components/InvoiceItemModal'));
ImportModalComponent(INVOICE_SEND_ROOTUI_TYPE, () => import('components/InvoiceSendModal'));
// Not 'components/RequestDialog', which resolves to the dev menu's RequestDialog.js.
ImportModalComponent(REQUEST_DIALOG, () => import('components/RequestDialog/index'));
ImportModalComponent(SALES_TAX_ROOTUI_TYPE, () => import('components/SalesTaxModal'));
ImportModalComponent(
  BUSINESS_INCOME_DEDUCTIONS_MODAL,
  () => import('components/TaxPlanner/BusinessIncomeDeductionsModal'),
);
ImportModalComponent(CREATE_TAX_SERIES_DIALOG, () => import('components/TaxPlanner/CreateTaxSeriesDialog'));
ImportModalComponent(FILING_DETAILS_MODAL, () => import('components/TaxPlanner/FilingDetailsModal'));
ImportModalComponent(HOW_WE_CALCULATE_MODAL, () => import('components/TaxPlanner/HowWeCalculateModal'));
ImportModalComponent(TAX_PLANNER_DIALOG, () => import('components/TaxPlanner/TaxPlannerDialog'));
ImportModalComponent(GENERATOR_DIALOG, () => import('components/Transactions/GeneratorDialog'));
ImportModalComponent(DIALOG_TYPE_EDIT_GOAL, () => import('containers/Goals/EditGoal'));
ImportModalComponent(UPGRADE_TO_BUSINESS_ROOTUI_TYPE, () => import('containers/UpgradeToBusiness/UpgradeToBusiness'));
